// JQ start here
(function($){

  function ctaheight(){
    $('.cta1-1').each( function(){
      var height = jQuery(this).find('.foreground').outerHeight(false);
      jQuery(this).find('.background').outerHeight(height);
    })
  
    $('.cta2-2').each( function(){
      var height = jQuery(this).find('.foreground .col1').outerHeight(false);
      var height2 = jQuery(this).find('.foreground .col2').outerHeight(false);
      console.log(height);
      console.log(height2);
      jQuery(this).find('.background .col1').outerHeight(height);
      jQuery(this).find('.background .col2').outerHeight(height2);
    })
  }

  //dom ready
  $(window).ready(function(){
    ctaheight();

    //Make elements equal height
    $('.matchHeight').matchHeight();
    $('.matchMinHeight').matchHeight({ property: 'min-height' });
    window.setTimeout(timeoutfunctions, 100);
    function timeoutfunctions() {
      $('.matchHeight').matchHeight();
      $('.matchMinHeight').matchHeight({ property: 'min-height' });
    }
  })

  $(window).resize(function(){
    ctaheight();
  })

  $(window).load(function() {
    $(window).trigger('resize');
  });
  
}(jQuery));